import { useEffect, useState } from "react";
import { loadAvatarGltf, peekAvatarGltf } from "../../players/playerDetailsCache";

export default function useV2AvatarModel() {
  const [gltf, setGltf] = useState(() => peekAvatarGltf());
  const [status, setStatus] = useState(() => (peekAvatarGltf() ? "ready" : "loading"));

  useEffect(() => {
    if (gltf) return undefined;
    let cancelled = false;
    setStatus("loading");
    loadAvatarGltf({ timeoutMs: 20000 })
      .then((model) => {
        if (!cancelled) {
          setGltf(model);
          setStatus("ready");
        }
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });
    return () => {
      cancelled = true;
    };
  }, [gltf]);

  return { gltf, status };
}
